import React from 'react';
import PropTypes from 'prop-types';
import { plus as PlusIcon } from 'common/svg/icons';

const UploadForm = ({ getInputProps, getRootProps, importError }) => (
  <div className="uploadfield__padded">
    <h3 className="text--header text--medium">Upload your shape file</h3>
    <p>
      Zip your .shp, .shx, .dbf, .prj file.
      <br />
      Max size limit 2GB.
    </p>
    {importError && (
      <p className="uploadfield__error">
        We cannot import this file. Please check the shape file and try
        uploading a new zip file again.
      </p>
    )}
    <div {...getRootProps({ className: 'uploadfield__dropzone' })}>
      <input {...getInputProps()} />
      <div className="uploadfield__dropzone__content">
        <p>Choose your file</p>
        <div className="uploadfield__dropzone__icon">
          <PlusIcon />
        </div>
      </div>
    </div>
  </div>
);
UploadForm.propTypes = {
  importError: PropTypes.bool.isRequired,
  getRootProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
};

export default UploadForm;



// WEBPACK FOOTER //
// ./src/pages/Field/Upload/UploadForm.js